import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { VVS_PTW_DATA_SHARE } from '../service/data_share.service';
import { INavbarData } from '../../layout/sidebar/helper';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router, private _Datashare: VVS_PTW_DATA_SHARE) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (typeof (this.authService.VVS_VOIS_CURRENT_USER_VALUE) != 'undefined' && this.authService.VVS_VOIS_CURRENT_USER_VALUE != null && this.authService.VVS_VOIS_CURRENT_USER_VALUE) {
      return true;
      // let aclList = this._Datashare.VVS_VOIS_GET_ACL_LIST();
      // console.log(aclList)
      // if (aclList.length > 0) {
      //   const requestedUrl = state.url.replace(/^\//, '');
      //   console.log(requestedUrl)
      //   const isAllowed = this.isRoutePermitted(requestedUrl, aclList);
      //   if (!isAllowed) {
      //     alert('Access denied: This page is not permitted.');
      //     this.authService.VVS_VOIS_LOGOUT();
      //     history.pushState(null, "null", window.location.href)
      //     this.router.navigate(['']);
      //     return false;
      //   } else {
      //     return true;
      //   }
      // } else {
      //   return true;
      // }
    }
    this.router.navigate(['/signin']);
    return false;
  }

  private isRoutePermitted(url: string, routes: INavbarData[]): boolean {
    for (const route of routes) {
      if (route.routerLink && route.routerLink === url) {
        return true;
      }
      if (route.items && this.isRoutePermitted(url, route.items)) {
        return true;
      }
    }
    return false;
  }

}


export const AuthGuardFn: CanActivateFn = (route, state) => {
  return inject(AuthGuard).canActivate(route, state);
}
